import { useState } from 'react';
import { Button } from '@bancobarigui/barihaus';
import { PlusOutlined, FileTextOutlined } from '@ant-design/icons';

interface EmptyStateProps {
  onAddGroup: () => void;
}

export function EmptyState({ onAddGroup }: EmptyStateProps) {
  const [isDragOver, setIsDragOver] = useState(false);

  const handleDragOver = (e: React.DragEvent) => {
    e.preventDefault();
    setIsDragOver(true);
  };

  const handleDragLeave = () => {
    setIsDragOver(false);
  };

  const handleDrop = (e: React.DragEvent) => {
    e.preventDefault();
    setIsDragOver(false);

    const controlType = e.dataTransfer.getData('text/plain');
    if (controlType === 'new-group') {
      onAddGroup();
    }
  };

  return (
    <div
      className={`flex flex-col items-center justify-center py-16 px-4 rounded-lg border-2 border-dashed ${
        isDragOver
          ? 'bg-blue-100 border-blue-400'
          : 'bg-gray-50 border-gray-300'
      }`}
      onDragOver={handleDragOver}
      onDragLeave={handleDragLeave}
      onDrop={handleDrop}
    >
      <FileTextOutlined className="text-6xl text-gray-400 mb-4" />

      <h3 className="text-xl font-semibold text-gray-700 mb-2">
        Nenhum grupo cadastrado
      </h3>

      <p className="text-gray-500 text-center mb-6 max-w-md">
        Comece criando um grupo para organizar as seções e perguntas do seu formulário.
        Você poderá adicionar seções e perguntas dentro de cada grupo.
      </p>

      <Button
        buttonColor="primary"
        size="middle"
        icon={<PlusOutlined />}
        onClick={onAddGroup}
      >
        Criar Primeiro Grupo
      </Button>
    </div>
  );
}
